import {
  ShippingRestrictionResponseDto,
  ShippingAppResponseDto,
} from '@tiendanube/common';
import { ShippingRestrictionScope } from '@tiendanube/common/src/enums';

export function allShippingMethodsHaveRestrictions(
  detailActiveApp: ShippingAppResponseDto | null | undefined,
  restrictions: ShippingRestrictionResponseDto[] | null | undefined,
): boolean {
  if (!detailActiveApp?.options || !restrictions) return false;

  const enabledMethodCodes = Object.entries(detailActiveApp.options)
    .filter(([, config]) => config.isEnabled)
    .map(([code]) => code);

  if (enabledMethodCodes.length === 0) return true;

  const hasAllScopeRestriction = restrictions.some(
    (restriction) =>
      restriction.shippingMethodsScope === ShippingRestrictionScope.ALL,
  );

  if (hasAllScopeRestriction) return true;

  const usedMethodCodes = new Set<string>();
  for (const restriction of restrictions) {
    for (const code of restriction.selectedShippingMethods ?? []) {
      usedMethodCodes.add(code);
    }
  }

  return enabledMethodCodes.every((code) => usedMethodCodes.has(code));
}
